import ScriptingEffect from './ScriptingEffect.js';
import {pipe} from './pipe.js';
import {
    execute,
    notes,
    steps,
    prob,
} from './lang.js';
import {patternSwitch} from './lang.js';

class PatternSwitchEffect extends ScriptingEffect {
    constructor(track) {
        super("Pattern Switch", track);
        this.newVar('patternNumber', 0, 0, 16);
        this.clear();
    }

    get documentation() {
        return [
            "Switches the pattern when a trigger is received."
        ];
    }

    getVisualizedParameters() {
        return [this.patternNumberParameter];
    }

    isRealTime() {
        return false;
    }

    clear() {
        this.myScript = pipe(
            patternSwitch(this.var('patternNumber')));
    }

    get script() {
        return this.myScript;
    }

    getCopy(track, ignoreId=true) {
        let fx = new PatternSwitchEffect(track);
        fx.fromJson(fx.getJson(), ignoreId);
        return fx;
    }
}


export default PatternSwitchEffect;
